import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { answerWithImageType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderRadioLikeButtonGroupWithImage } from '../../views/RadioLikeButtonGroupWithImage';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

import RoofShapeHipRoofPngPath from 'Images/me/pages/guest/proposals/new/roof_shape/hip_roof.png'
import RoofShapeHipRoofWebPPath from 'Images/me/pages/guest/proposals/new/roof_shape/hip_roof.webp'
import RoofShapeGablePngPath from 'Images/me/pages/guest/proposals/new/roof_shape/gable.png'
import RoofShapeGableWebPPath from 'Images/me/pages/guest/proposals/new/roof_shape/gable.webp'
import RoofShapeSingleSlopePngPath from 'Images/me/pages/guest/proposals/new/roof_shape/single_slope.png'
import RoofShapeSingleSlopeWebPPath from 'Images/me/pages/guest/proposals/new/roof_shape/single_slope.webp'
import RoofShapeFlatPngPath from 'Images/me/pages/guest/proposals/new/roof_shape/flat.png'
import RoofShapeFlatWebPPath from 'Images/me/pages/guest/proposals/new/roof_shape/flat.webp'

const SECTION_KEY_NAME = 'roofShape';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'roofShape';

export const roofShapeSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: answerWithImageType[] = [
    {
      value: '寄棟',
      imagePaths: {
        imagePath: RoofShapeHipRoofPngPath,
        webp: RoofShapeHipRoofWebPPath,
      }
    },
    {
      value: '切妻',
      imagePaths: {
        imagePath: RoofShapeGablePngPath,
        webp: RoofShapeGableWebPPath,
      }
    },
    {
      value: '片流れ',
      imagePaths: {
        imagePath: RoofShapeSingleSlopePngPath,
        webp: RoofShapeSingleSlopeWebPPath,
      }
    },
    {
      value: '陸屋根',
      imagePaths: {
        imagePath: RoofShapeFlatPngPath,
        webp: RoofShapeFlatWebPPath,
      }
    },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '屋根の形は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        屋根はどのような形ですか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderRadioLikeButtonGroupWithImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
